import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import GererPage from "./pages/GererPage";
import CommandePage from "./pages/CommandePage";
import MenuPage from "./pages/MenuPage";
import ProductionPage from "./pages/ProductionPage";
import SalesPage from "./pages/SalesPage";
import TeamPage from "./pages/TeamPage";
import RecipesPage from "./pages/RecipesPage";
import InvitePage from "./pages/InvitePage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AdminRolesPage from "./pages/AdminRolesPage";
import ReportsPage from "./pages/ReportsPage";

// Garde d'accès pilotée par la matrice de permissions (user.permissions) ; redirige vers la première page autorisée
const FALLBACK = [["create_prep_list", "/gerer"], ["view_own_tasks", "/"], ["view_menu", "/menu"], ["view_recipes", "/recettes"]];
const Guard = ({ perm, children }) => {
  const { user, hasPermission } = useAuth();
  if (!user) return children;
  if ([].concat(perm).some(hasPermission)) return children;
  const target = FALLBACK.find(([p, to]) => hasPermission(p) && to !== window.location.pathname)?.[1] || "/";
  return <Navigate to={target} replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/invite/:token" element={<InvitePage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Guard perm="view_own_tasks"><DashboardPage /></Guard>} />
            <Route path="/gerer" element={<Guard perm="view_own_tasks"><GererPage /></Guard>} />
            <Route path="/commande" element={<Guard perm={["view_own_order_requests", "view_orders", "create_order", "receive_order"]}><CommandePage /></Guard>} />
            <Route path="/menu" element={<Guard perm="view_menu"><MenuPage /></Guard>} />
            <Route path="/recettes" element={<Guard perm="view_recipes"><RecipesPage /></Guard>} />
            <Route path="/production" element={<Guard perm="view_production"><ProductionPage /></Guard>} />
            <Route path="/sales" element={<Guard perm="view_sales"><SalesPage /></Guard>} />
            <Route path="/rapports" element={<Guard perm="view_reports"><ReportsPage /></Guard>} />
            <Route path="/team" element={<Guard perm="view_team"><TeamPage /></Guard>} />
            <Route path="/demandes" element={<Navigate to="/commande?tab=demandes" replace />} />
            <Route path="/order-requests" element={<Navigate to="/commande?tab=demandes" replace />} />
            <Route path="/administration" element={<Guard perm="manage_roles"><AdminRolesPage /></Guard>} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-center"
        toastOptions={{
          style: {
            borderRadius: '12px',
            fontFamily: 'Plus Jakarta Sans, sans-serif',
            background: '#ffffff',
            color: '#18181b',
            border: '1px solid #e5e7eb',
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
